<t-llevo-overlay-button 
	[value]="label" 
	[disableClose]="disableClose" 
	[disabled]="disabled"
	[matBadge]="selectedItems.length" 
	[matBadgeHidden]="hideBadge || selectedItems.length === 0" 
	matBadgeColor="accent"
>
  <div class="bg-light shadow">
    @for(item of data; track item){
    <div
      style="min-height: 50px; min-width: 200px; cursor: pointer;"
      class="d-flex align-items-center border-bottom px-2 py-1 select-item"
			[class.selected]="isItemSelected(item.id)"
			(click)="isItemSelected(item.id)? deselectItem(item.id): selectItem(item.id)"
    >
      <mat-pseudo-checkbox [state]="isItemSelected(item.id)? 'checked': 'unchecked'"></mat-pseudo-checkbox>
      <span class="mx-2">{{ item.value }}</span>
		</div>
    }

		@if(selectedItems.length > 0){
		<div class="mt-1">
			<button mat-flat-button color="primary" class="w-100" (click)="deselectAll()">
				{{cancelSelectionText}}
			</button>
		</div>
		}
  </div>
</t-llevo-overlay-button>
